import React, { Component } from "react";
import { connect } from "react-redux";
import {createMateriel} from "../actions/materiel";
import MaterielsDataService from "../services/materiel.service";

class AddMateriel extends Component {
  constructor(props) {
    super(props);
    this.onChangeNom = this.onChangeNom.bind(this);
    this.onChangeProvenance=this.onChangeProvenance.bind(this);
    this.newMateriel = this.newMateriel.bind(this);
    this.saveMateriel=this.saveMateriel.bind(this);

    this.state = {
      id: null,
      Nom: "",
      Entreprise:"",
      submitted: false,
      message: "",

    };
  }





  onChangeNom(e) {
    this.setState({
      Nom: e.target.value,
    });
  }

  onChangeProvenance(e) {
    this.setState({
      Entreprise: e.target.value,
    });
  }



  newMateriel() {
    this.setState({

      id: null,
      Nom: "",
      Entreprise: "",
    });
  }

    saveMateriel() {
      const data = {
        Nom: this.state.Nom,
        Entreprise: this.state.Entreprise
      };

      MaterielsDataService.create(data)
          .then(response => {
            this.setState({
              id: response.data.id,
              Nom: response.data.Nom,
              Entreprise: response.data.Entreprise,
              published: response.data.published,

              submitted: true
            });
            console.log(response.data);
          })
          .catch(e => {
            console.log(e);
          });
    }



  render() {
    const {message
    } = this.state;

    return (
        <div>
        <div>

          <div className="alert alert-light" role="alert">
            <p>{message}</p>
          </div>
        </div>

    <div className="submit-form">
      {this.state.submitted ? (
          <div>
            <h4>Ajout réussi !</h4>
            <a className="btn btn-success" onClick={this.newMateriel} href="https://pointage.ansart-tp.com/materiels">
              Revenir à la liste du matériel
            </a>
          </div>
      ) : (
          <div>
            <div className="form-group">
              <label htmlFor="Nom">Designation </label>
              <input
                  type="text"
                  className="form-control"
                  id="Nom"
                  required
                  value={this.state.Nom}
                  onChange={this.onChangeNom}
                  name="Nom"
              />
              <label htmlFor="Provenance">Entreprise</label>
              <input
                  type="text"
                  className="form-control"
                  id="Provenance"
                  required
                  value={this.state.Entreprise}
                  onChange={this.onChangeProvenance}
                  name="Provenance"
              />
            </div>

            <button onClick={this.saveMateriel} className="btn btn-success">
              Ajouter
            </button>
          </div>
      )}
    </div>

        </div>
    );
  }
}


export default connect(null, { createMateriel })(AddMateriel);


